import { HTML5Backend } from 'react-dnd-html5-backend';
import { createTransition, DndProviderProps } from 'react-dnd-multi-backend';
import { TouchBackend } from 'react-dnd-touch-backend';

export const TouchTransition = createTransition('touchstart', () => {
  return 'ontouchstart' in window;
});

export const multiBackendOptions: DndProviderProps['options'] = {
  backends: [
    {
      id: 'html5',
      backend: HTML5Backend,
      transition: undefined, // default for desktop
    },
    {
      id: 'touch',
      backend: TouchBackend,
      options: {
        enableMouseEvents: true,
        delayTouchStart: 300, // long press delay (in ms)
      },
      preview: true,
      transition: TouchTransition,
    },
  ],
};
